<!-- Translated: skip -->
<template>
  <Modal @close="closeModal" :wide="false" width="427px">
    <div class="center">
      <h1>Dela dina sparade bokningar</h1>

      <p>Klicka på <b>kopiera länken</b> nedan och klistra in länken och dela den. Du kan också spara den som en av dina favoriter i webbläsaren.</p>

      <br>

      <input ref="copyText" type="text" :value="link" readonly />

      <br>
      <br>
      <br>

      <button class="medium" @click="copy">Kopiera länken</button>
    </div>
  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
  },
  data() {
    return {
    };
  },
  mounted() {
    this.$refs.copyText.select();
  },
  computed: {
    link() {
      const protocol = window.location.protocol;
      const host = window.location.host;
      const page = window.location.pathname;
      // const path = this.$router.history.current.fullPath;
      const accomodations = this.params.accomodations;
      return `${protocol}//${host}${page}#/dela/j/${accomodations}`;
    },
  },
  methods: {
    ...mapMutations([
      'closeModal',
    ]),
    copy() {
      this.$refs.copyText.select();
      document.execCommand('copy');
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'
h1
  united-heavy()
  color: #262626;
  text-align: center;
  font-size: 22px;
  font-weight: 900;
  margin-bottom 15px
p
  font-size: 14px;
  font-weight: 300;
  line-height: 1.49;

input
  input()
  min-width 100%
  max-width 100%
  centered()
</style>



// WEBPACK FOOTER //
// AccomodationCompareShare.vue?35218ff8